/**
 * Returns base domain without tenant or admin prefix.
 *
 * On 'xyz.fyzion.app'      with slug 'xyz'  → 'fyzion.app'
 * On 'fyzion.app'          with slug 'xyz'  → 'fyzion.app'
 * On 'my.mindapp.cz'       with slug 'xyz'  → 'my.mindapp.cz'
 * On 'xyz.my.mindapp.cz'   with slug 'xyz'  → 'my.mindapp.cz'
 * On 'app.fyzion.cz'       with slug 'xyz'  → 'fyzion.cz'  (BASE_ADMIN_PREFIX=app)
 * On 'app.fyzion.sk'       with slug 'xyz'  → 'fyzion.sk'  (BASE_ADMIN_PREFIX=app)
 */
export function getBaseDomain(tenantSlug?: string | null): string {
  const hostname = window.location.hostname;
  // 'app' is the default admin portal prefix (e.g. app.fyzion.cz → fyzion.cz).
  // Override via BASE_ADMIN_PREFIX for non-standard deployments.
  const adminPrefix = process.env.BASE_ADMIN_PREFIX ?? 'app';
  if (hostname.startsWith(`${adminPrefix}.`)) {
    return hostname.slice(adminPrefix.length + 1);
  }
  if (tenantSlug && hostname.startsWith(`${tenantSlug}.`)) {
    return hostname.slice(tenantSlug.length + 1);
  }
  return hostname;
}

export function buildSubdomainUrl(slug: string): string {
  return `${slug}.${getBaseDomain(slug)}`;
}

// Returns candidate tenant slug from hostname — must be validated via API.
export function detectTenantSlug(): string | null {
  const parts = window.location.hostname.split('.');
  return parts.length > 2 ? parts[0] : null;
}
